import axios from 'axios';
import { GET_OPTIONS_GROUPS_URL } from '../constants';

export function getOptionsGroups() {
  return axios.get(GET_OPTIONS_GROUPS_URL);
}
